<template>
    <div class="catalogue">
        <div class="header-tool">
            <div class="header-tool-info">
                <Breadcrumb>
                    <BreadcrumbItem>展会管理</BreadcrumbItem>
                    <BreadcrumbItem>邮箱配置</BreadcrumbItem>
                </Breadcrumb>
                <div class="header-tool-title">邮箱配置</div>
            </div>
        </div>

        <div class="catalogue-content">
            <div style="display:flex;">
                <div class="catalogue-content-l">
                    <Form
                            ref="formInline"
                            :model="formInline"
                            :rules="ruleInline"
                            label-position="right"
                            :label-width="200"
                            @submit.native.prevent
                    >
                        <FormItem label="发件人名称：" prop="name">
                            <Input
                                    type="text"
                                    v-model="formInline.name"
                                    placeholder="请输入发件人名称"
                            />
                        </FormItem>

                        <FormItem label="邮箱：" required prop="mailAccount">
                                        <Input
                                                type="text"
                                                v-model="formInline.mailAccount"
                                                placeholder="请填写邮箱"

                                        />
                        </FormItem>
                        <FormItem label="密码：" prop="mailPwd" required>
                            <Input
                                    type="password"
                                    v-model="formInline.mailPwd"
                                    placeholder="请输入密码"

                            />
                        </FormItem>

                        <FormItem label="smtp：" prop="mailSMTP">
                            <Input
                                    type="text"
                                    v-model="formInline.mailSMTP"
                                    placeholder="请输入smtp"
                            />
                        </FormItem>
                        <FormItem label="端口：" prop="mailPort">
                            <Input
                                    type="number"
                                    v-model="formInline.mailPort"
                                    placeholder="请输入端口号"
                            />
                        </FormItem>

                        <FormItem label="" required style="margin-bottom: 0;">
                          <Checkbox  v-model="formInline.isSsl">是否启用安全外链</Checkbox >
                        </FormItem>
                        <FormItem style="padding-top: 20px;">
                            <Button
                                    type="primary"
                                    size="large"
                                    @click="handleSubmit('formInline')"
                                    style="width: 154px;"
                            >保存</Button>
                        </FormItem>
                    </Form>
                </div>

            </div>
        </div>


    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";


    export default {
        name: "exhibition-info-catalogue",
        data() {

            return {
                formInline: {
                    name: "", // 发件人名称
                    mailAccount: "", // 邮箱地址
                    mailPwd: "", // 邮箱密码
                    mailSMTP: "",//
                    mailPort: '',//端口号
                    isSsl:true

                },
                ruleInline: {
                    name: [
                        { required: true, message: "请输入发件人名称", trigger: "blur" }
                    ],
                    mailAccount: [
                        { required: true, message: "请输入邮箱地址", trigger: "blur" },
                        { type: 'email', message: '请输入正确邮箱地址', trigger: 'blur' }
                    ],
                    mailPwd: [
                        { required: true, message:  "请输入密码", trigger: "blur" }
                    ],
                    mailSMTP: [
                        { required: true, message: "请输入smtp", trigger: "blur" }
                    ],

                    mailPort: [
                        { required: true, message: "请输入端口号", trigger: "blur" }
                    ],



                },

            };
        },
        components: {

        },
        computed: {
            ...mapGetters({
                formHeaders: "getFormHeaders",
                uploadUrl: "getUploadUrl",
                joinInfo: "loginModule/getJoinInfo",
                company: "loginModule/getCompany",
                exhibition: "loginModule/getExhibition"
            }),
            exhibitionId() {
                return this.exhibition.id;
            }
        },
        created() {
            document.title = "国际焙烤展 - 邮箱配置";
            this.init();
        },
        methods: {
            ...mapActions({
                getEmail: "exhibitionModule/getEmail",
                editEmail:"exhibitionModule/editEmail"
            }),
            async init() {
                let data=await this.getEmail()
                console.log(data,'data')
                if(data){

                    this.formInline.name=data.name
                    this.formInline.mailAccount=data.mailAccount
                    this.formInline.mailPwd=data.mailPwd
                    this.formInline.mailSMTP=data.mailSMTP
                    this.formInline.mailPort=data.mailPort+''
                    this.formInline.isSsl=data.isSsl
                    this.formInline.id=data.id

                }
            },
            async handleSubmit(name) {

                console.log(this.formInline)
                let valid = await this.validForm(name);
                if (valid){
                    this.formInline.mailPort=parseInt(this.formInline.mailPort)
                    let opt={
                        Id: this.formInline.id,
                        SetValues:{
                            Name:this.formInline.name,
                            MailAccount:this.formInline.mailAccount,
                            MailPwd:this.formInline.mailPwd,
                            MailSMTP:this.formInline.mailSMTP,
                            IsSsl:this.formInline.isSsl,
                            MailPort:this.formInline.mailPort,
                        }
                    }
                     let  data1=await this.editEmail(opt)
                    if(data1.successed){
                        this.$Message.success('修改成功 ');
                    }
                else{
                        this.$Message.error('修改失败');
                    }
                }
            },

            validForm(name) {
                // 验证表单
                return new Promise((resolve, reject) => {
                    this.$refs[name].validate(valid => {
                        resolve(valid);
                    });
                });
            },

        }
    };
</script>

<style lang="scss">
    .intTextarea {
        .ivu-form-item-error-tip {
            top: 75%;
        }
    }
    .no-label {
        .ivu-form-item-label:before {
            opacity: 0 !important;
        }
    }
</style>
<style scoped lang="scss">
    .catalogue {
        .header-tool {
            min-height: 90px;
        }
        &-content {
            min-width: 1400px;
            margin: 30px;
            padding: 40px;
            min-height: 500px;
            background: #fff;
            padding-bottom: 190px;
            .catalogue-tip {
                color: #ff0000;
                padding: 0 0 5px 200px;
                .txt {
                    padding-left: 10px;
                    color: #1890ff;
                    &:hover {
                        cursor: pointer;
                    }
                }
            }
            &-l {
                width: 50%;
                min-width: 700px;
            }
            &-r {
                display: flex;
                // min-width: 700px;
                .logo-example {
                    display: flex;
                    &-box {
                        display: flex;
                        flex-wrap: wrap;
                        flex: 1;
                    }
                    &-item {
                        display: flex;
                        width: 100%;
                        p {
                            font-size: 12px;
                            color: #808080;
                            padding-left: 10px;
                        }
                        &.z-large-s {
                            img {
                                width: 40px;
                                height: 40px;
                                border: 1px solid #bfbfbf;
                            }
                            p {
                                line-height: 40px;
                            }
                        }
                        &.z-large-m {
                            img {
                                width: 30px;
                                height: 30px;
                                border: 1px solid #bfbfbf;
                            }
                            p {
                                line-height: 30px;
                            }
                        }
                        &.z-large-l {
                            img {
                                width: 20px;
                                height: 20px;
                                border: 1px solid #bfbfbf;
                            }
                            p {
                                line-height: 20px;
                            }
                        }
                    }
                }
            }
        }
        .mask {
            &:hover {
                cursor: pointer;
            }
        }
    }
</style>
